var _defs, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRecipeOnsiteIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 100,
    zoomAndPan: "magnify",
    viewBox: "0 0 75 74.999997",
    height: 100,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "8d17cefaa2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 7.5 7.5 L 68 7.5 L 68 68 L 7.5 68 Z M 7.5 7.5 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "d01a4a3ae9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 22.703125 24.339844 L 51.027344 24.339844 L 51.027344 52.664062 L 22.703125 52.664062 Z M 22.703125 24.339844 ",
    clipRule: "nonzero"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#8d17cefaa2)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#723fa3",
    d: "M 37.46875 67.4375 C 20.910156 67.4375 7.5 53.933594 7.5 37.46875 C 7.5 21.003906 20.910156 7.5 37.46875 7.5 C 54.027344 7.5 67.4375 20.910156 67.4375 37.46875 C 67.4375 54.027344 53.933594 67.4375 37.46875 67.4375 Z M 37.46875 9.351562 C 21.929688 9.351562 9.351562 21.929688 9.351562 37.46875 C 9.351562 53.007812 21.929688 65.589844 37.46875 65.589844 C 53.007812 65.589844 65.589844 53.007812 65.589844 37.46875 C 65.589844 21.929688 52.914062 9.351562 37.46875 9.351562 Z M 37.46875 9.351562 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#d01a4a3ae9)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#723fa3",
    d: "M 28.433594 47.566406 L 28.433594 53.09375 L 35.484375 47.566406 L 48.660156 47.566406 C 50.664062 47.566406 52.292969 45.941406 52.292969 43.9375 L 52.292969 27.984375 C 52.292969 25.980469 50.664062 24.355469 48.660156 24.355469 L 26.332031 24.355469 C 24.328125 24.355469 22.703125 25.980469 22.703125 27.984375 L 22.703125 43.9375 C 22.703125 45.941406 24.328125 47.566406 26.332031 47.566406 L 28.433594 47.566406 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecipeOnsiteIcon);
export default __webpack_public_path__ + "static/media/Recipe - Onsite Icon.499d3674ea933e2649e156fd41f7d433.svg";
export { ForwardRef as ReactComponent };